export class ValueUtils {

  /**
   * Checks if the given value is neither undefined nor null.
   *
   * @param val - The value to check.
   * @returns true if the value is defined and not null, false otherwise.
   *
   * @example
   * const result = ValueUtils.isValuePresent(123); // true
   * const result = ValueUtils.isValuePresent(null); // false
   */
  static isValuePresent<T>(val: T): boolean {
    return val !== undefined && val !== null;
  }

  /**
   * Checks if the given value is either undefined or null.
   *
   * @param val - The value to check.
   * @returns true if the value is undefined or null, false otherwise.
   *
   * @example
   * const result = ValueUtils.isValueAbsent(123); // false
   * const result = ValueUtils.isValueAbsent(null); // true
   */
  static isValueAbsent<T>(val: T): boolean {
    return val === undefined || val === null;
  }
}
